import * as keyapis_access_control_v1_access_control_pb from "./v1/keyapis_access_control_access_control_v1.pb";
import * as keyapis_access_control_v1_access_point_pb from "./v1/keyapis_access_control_access_point_v1.pb";
import * as keyapis_access_control_v1_access_point_group_pb from "./v1/keyapis_access_control_access_point_group_v1.pb";
import * as keyapis_access_control_v1_access_zone_pb from "./v1/keyapis_access_control_access_zone_v1.pb";
import * as keyapis_access_control_v1_broadcast_alert_pb from "./v1/keyapis_access_control_broadcast_alert_v1.pb";
import * as keyapis_access_control_v1_building_pb from "./v1/keyapis_access_control_building_v1.pb";
import * as keyapis_access_control_v1_entrance_pb from "./v1/keyapis_access_control_entrance_v1.pb";
import * as keyapis_access_control_v1_events_1_pb from "./v1/keyapis_access_control_events_1.pb";
import * as keyapis_access_control_v1_flatgramm_pb from "./v1/keyapis_access_control_flatgramm_v1.pb";
import * as keyapis_access_control_v1_rfid_pb from "./v1/keyapis_access_control_rfid_v1.pb";
import * as keyapis_access_control_v1_room_device_pb from "./v1/keyapis_access_control_room_device_v1.pb";
import * as keyapis_access_control_v1_room_user_pb from "./v1/keyapis_access_control_room_user_v1.pb";
import * as keyapis_access_control_v1_sync_pb from "./v1/keyapis_access_control_sync_v1.pb";
import * as keyapis_access_control_v1_system_pb from "./v1/keyapis_access_control_system_v1.pb";

export default {
  v1: {
    resources: {
      accessControl: keyapis_access_control_v1_access_control_pb,
      accessPoint: keyapis_access_control_v1_access_point_pb,
      accessPointGroup: keyapis_access_control_v1_access_point_group_pb,
      accessZone: keyapis_access_control_v1_access_zone_pb,
      broadcastAlert: keyapis_access_control_v1_broadcast_alert_pb,
      building: keyapis_access_control_v1_building_pb,
      entrance: keyapis_access_control_v1_entrance_pb,
      events_1: keyapis_access_control_v1_events_1_pb,
      flatgramm: keyapis_access_control_v1_flatgramm_pb,
      rfid: keyapis_access_control_v1_rfid_pb,
      roomDevice: keyapis_access_control_v1_room_device_pb,
      roomUser: keyapis_access_control_v1_room_user_pb,
      sync: keyapis_access_control_v1_sync_pb,
      system: keyapis_access_control_v1_system_pb,
    },
  },
};
